const { createSelector } = require('reselect');

const getUserFunds = (state, props) => {
    try {
        if (props.isAlternativeFund) {
            return state.brokerMyInvestments.toJS().products.alternativeFunds.stocks.filter(f=>!!f.isin);
        } else {
            return state.brokerMyInvestments.toJS().products.funds.stocks.filter(f=>!!f.isin);
        }
    } catch (e) {
        return [];
    }
};

const getIdType = (state, props) => (
    {
        isin: 'isin',
        secid: 'secid',
        cisid: 'customInstitutionSecurityId',
    }[props.match.params.idType]
);

const getId = (state, props) => props.match.params.id;

const getFunds = state => state.brokerInvestmentFunds || [];

const getContractId = (state, props) => {
    if(props.location) {
        const query = new URLSearchParams(props.location.search);
        return query.get('contractId') ? query.get('contractId') : null;
    }
    return null;
};


const selectUserFund = createSelector(
    [getUserFunds, getIdType, getId, getContractId],
    (funds, idType, id, idContract) => funds.find(fund => fund[idType] === id && fund['id'] === idContract)
);

const selectUserFundNext = createSelector(
    [getUserFunds, getIdType, getId, getContractId],
    (funds, idType, id, idContract) => {
        const i = funds.findIndex(fund => fund[idType] === id && fund['id'] === idContract);
        if (i < 0) return null;
        if (i + 1 > funds.length - 1) return funds[0];
        return funds[i + 1];
    }
);

const selectUserFundPrev = createSelector(
    [getUserFunds, getIdType, getId, getContractId],
    (funds, idType, id, idContract) => {
        const i = funds.findIndex(fund => fund[idType] === id && fund['id'] === idContract);
        if (i < 0) return null;
        if (i === 0) return funds[funds.length - 1];
        return funds[i - 1];
    }
);

const selectFund = createSelector(
    [getFunds, getIdType, getId],
    (funds, idType, id) => funds.find(fund => fund[idType] === id)
);

module.exports = {
    selectFund,
    selectUserFund,
    selectUserFundNext,
    selectUserFundPrev,
    selectUserFunds: getUserFunds,
};
